import { queryClient } from 'index';
import { useTranslation } from 'react-i18next';
import { useInfiniteQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { addBuyer, getEligibleBuyers } from 'services/CompanyService';
import { LogyxError, getToastErrorMessage } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getNextPageParam } from 'utils/getNextPageParam';

export interface IAddBuyerDTO {
  companyId: number;
  reference: string;
}

export const useAddBuyer = () => {
  const { t } = useTranslation();
  return useMutation(
    (params: IAddBuyerDTO) => addBuyer(params.companyId, params.reference),
    {
      onSuccess: () => {
        toast.success(t('Buyer is added'));
        queryClient.invalidateQueries([ReactQueryKeys.GET_COMPANY_BUYERS]);
        queryClient.invalidateQueries([ReactQueryKeys.GET_ELIGIBLE_BUYERS]);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error));
      },
      mutationKey: ReactMutationKeys.ADD_BUYER,
    }
  );
};

export const useGetEligibleBuyers = (
  perPage: number,
  searchBy: string,
  isOpen: boolean
) =>
  useInfiniteQuery({
    queryKey: [ReactQueryKeys.GET_ELIGIBLE_BUYERS, perPage, searchBy],
    queryFn: ({ pageParam = 1 }) =>
      getEligibleBuyers(pageParam, perPage, searchBy),
    getNextPageParam,
    onSuccess: (data) => {
      return data;
    },
    enabled: isOpen,
  });
